export const aciMenuItems = {
    iconName: 'menu-items',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: {
            attr: {
                'clip-rule': 'evenodd',
                d: 'M8.25 3.247a1.5 1.5 0 011.5-1.5h12a1.5 1.5 0 011.5 1.5v1.5a1.5 1.5 0 01-1.5 1.5h-12a1.5 1.5 0 01-1.5-1.5v-1.5zM8.25 12.247a1.5 1.5 0 011.5-1.5h12a1.5 1.5 0 011.5 1.5v1.5a1.5 1.5 0 01-1.5 1.5h-12a1.5 1.5 0 01-1.5-1.5v-1.5zM8.25 21.247a1.5 1.5 0 011.5-1.5h12a1.5 1.5 0 011.5 1.5v1.5a1.5 1.5 0 01-1.5 1.5h-12a1.5 1.5 0 01-1.5-1.5v-1.5zM.75 3.247a1.5 1.5 0 011.5-1.5h1.5a1.5 1.5 0 011.5 1.5v1.5a1.5 1.5 0 01-1.5 1.5h-1.5a1.5 1.5 0 01-1.5-1.5v-1.5zM.75 12.247a1.5 1.5 0 011.5-1.5h1.5a1.5 1.5 0 011.5 1.5v1.5a1.5 1.5 0 01-1.5 1.5h-1.5a1.5 1.5 0 01-1.5-1.5v-1.5zM.75 21.247a1.5 1.5 0 011.5-1.5h1.5a1.5 1.5 0 011.5 1.5v1.5a1.5 1.5 0 01-1.5 1.5h-1.5a1.5 1.5 0 01-1.5-1.5v-1.5z',
                stroke: 'currentColor',
                'stroke-width': '1.5',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
